import React from "react";
import "../.././../node_modules/bootstrap/dist/css/bootstrap.min.css";
import GoogleTranslate from "../translator/TranslateButton";
import "./Upheader.css";

const Upheader = () => {
  return (
    <header className="bg-gradient-global-export text-white py-1 mb-0 shadow upheader-compact">
      <div className="container text-center text-md-left">
        <div className="row align-items-center">
          <div className="col-md-5 col-lg-4 col-xl-4 mx-auto mt-0 mb-0 pt-0 pb-0">
            <div className="shadow upheader-text-compact">
              <small>
                Welcome To{" "}
                <strong className="text-warning">
                  Shri Gwal Exim Pvt. Ltd.
                </strong>
              </small>
              <br />
              <small>
                <span className="text-warning">CIN -</span>{" "}
                <span className="text-white">U47219DL2023PTC424007</span>
              </small>
            </div>
          </div>

          <div className="col-md-4 col-lg-4 col-xl-4 mx-auto mt-1">
            {/* <div className="shadow upheader-text-compact">
              <small>
                <i className="bi bi-geo-alt" style={{ marginRight: '5px' }}></i><strong className="text-white">Delhi, India 110059</strong>
              </small><br />
              <small>
                <span className="text-warning">
                  <i
                    className="bi bi-envelope-paper"
                    style={{ marginRight: "5px" }}
                  ></i>{" "}
                  <span className=" text-white">info@shrigwalexim.com</span>
                </span>
              </small>
            </div> */}
          </div>
          <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mt-1">
            <div className="shadow upheader-text-compact">
              <small>
                <strong className="text-white">
                  {" "}
                  <GoogleTranslate />{" "}
                </strong>
              </small>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Upheader;
